import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TravelsListComponent } from './travels-list/travels-list.component';
import { TravelPageComponent } from './travel-page/travel-page.component';
import { AllDestinationsComponent } from './all-destinations/all-destinations.component';
import { DeparturesComponent } from './departures/departures.component';
import { TravelManagementComponent } from './travel-management/travel-management.component';
import { TravelManagementUserComponent } from './travel-management-user/travel-management-user.component';
import { NewTravelComponent } from './new-travel/new-travel.component';
import { loggedGuard } from '../../guards/logged/logged.guard';
import { SearchTravelsComponent } from './search-travels/search-travels.component';
import { TravelJoinComponent } from './travel-join/travel-join.component';
import { TravelJoinGMGComponent } from './travel-join-gmg/travel-join-gmg.component';

import { EnumEventType } from '../../shared/utils/enum-event-type';
import { TravelJoinDonateComponent } from './travel-join-donate/travel-join-donate.component';
import { travelAccessGuard } from '../../guards/guards/travel-access.guard';
import { userAccessGuard } from '../../guards/guards/user-access.guard';
import { communityGuard } from '../../guards/guards/community.guard';
//import { hasUnsavedChangesGuard } from '../../guards/deactivate/canDeactivate';

const routes: Routes = [
  { path: '', component: AllDestinationsComponent },

  { path: 'departures', component: DeparturesComponent },
  {
    path: 'travel-management/:travel_id',
    component: TravelManagementComponent,
    canActivate: [loggedGuard, travelAccessGuard],
  },
  {
    path: 'travel-management-user/:identifier',
    component: TravelManagementUserComponent,
    canActivate: [loggedGuard, userAccessGuard],
  },
  {
    path: 'new-travel',
    component: NewTravelComponent,
    canActivate: [loggedGuard],
    data: { travel_type: EnumEventType.STANDARD },
  },
  {
    path: 'edit-draft/:id',
    component: NewTravelComponent,
    canActivate: [loggedGuard],
    data: { travel_type: EnumEventType.STANDARD }, //aggiunto
  },
  {
    path: 'edit-draft-gmg/:id', //aggiunto
    component: NewTravelComponent,
    canActivate: [loggedGuard],
    data: { travel_type: EnumEventType.GMG }, //aggiunto
  },
  {
    path: 'edit-travel/:travel_id',
    component: NewTravelComponent,
    canActivate: [loggedGuard],
    data: { travel_type: EnumEventType.STANDARD }, //aggiunto
  },
  {
    path: 'edit-travel-gmg/:travel_id', //aggiunto
    component: NewTravelComponent,
    canActivate: [loggedGuard],
    data: { travel_type: EnumEventType.GMG }, //aggiunto
  },
  {
    path: 'new-travel-gmg',
    component: NewTravelComponent,
    canActivate: [loggedGuard],
    data: { travel_type: EnumEventType.GMG },
  },
  {
    path: 'join/:travel-name/:id',
    component: TravelJoinComponent,
    canActivate: [loggedGuard, communityGuard],
  },
  {
    path: 'join-gmg/:travel-name/:id',
    component: TravelJoinGMGComponent,
  }, // nuova rotta per GMG
  {
    path: 'join-donate/:travel-name/:id',
    component: TravelJoinDonateComponent,
  }, // nuova rotta per GMG
  {
    path: 'join-guest/:travel-name/:id',
    component: TravelJoinComponent,
    data: { guest: true },
  }, //rotta per i travelers che non hanno l'utenza (guests)
  { path: 'search', component: SearchTravelsComponent },
  { path: ':iso/:name', component: TravelsListComponent },
  { path: ':iso/:name/:id/:travel-name', component: TravelPageComponent },

  //{path: 'my-travels/:my_travel_id/:travel-name', component: TravelPageComponent},
  //{path: 'my-favs/:my_fav_id/:travel-name', component: TravelPageComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TravelsRoutingModule {}
